import { useEffect, useState } from "react";
import { Loader2, Paperclip } from "lucide-react";

export type AgreementAttachmentLinkRequirement = {
  id: string;
  label: string;
};

export default function AgreementAttachmentLinks({
  requestId,
  requirements,
}: {
  requestId: string;
  requirements: AgreementAttachmentLinkRequirement[];
}) {
  const [uploaded, setUploaded] = useState<Set<string> | null>(null);
  useEffect(() => {
    if (!requirements.length) {
      setUploaded(new Set());
      return;
    }
    let active = true;
    void fetch(`/api/agreements/admin/requests/${requestId}/attachments`)
      .then(async response => {
        if (!response.ok) throw new Error("Attachments are unavailable.");
        return (await response.json()) as Array<{ requirementId: string }>;
      })
      .then(items => {
        if (active) setUploaded(new Set(items.map(item => item.requirementId)));
      })
      .catch(() => {
        if (active) setUploaded(new Set());
      });
    return () => {
      active = false;
    };
  }, [requestId, requirements.length]);
  if (!requirements.length) return null;
  if (!uploaded)
    return <Loader2 className="h-3.5 w-3.5 animate-spin text-gray-400" />;
  return (
    <div className="flex flex-wrap gap-x-2 gap-y-1">
      {requirements
        .filter(requirement => uploaded.has(requirement.id))
        .map(requirement => (
          <a
            key={requirement.id}
            href={`/api/agreements/admin/requests/${requestId}/attachments/${requirement.id}`}
            className="inline-flex items-center gap-1 text-xs font-semibold text-[#6f923d] underline"
          >
            <Paperclip className="h-3 w-3" />
            {requirement.label}
          </a>
        ))}
    </div>
  );
}
